module.exports = __webpack_public_path__ + "static/media/plus.263881f5.svg";